import { render, staticRenderFns } from "./ProposalReport.vue?vue&type=template&id=80e7ee80"
import script from "./ProposalReport.vue?vue&type=script&lang=js"
export * from "./ProposalReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports